const infoSitio = {
  // descripcion:
  //   "Tienda de EJEMPLO de productos truper a Mayoreo, con envíos a todo México.",
  // negocio: "Mi Tienda",
  // direccion: ["Oaxaca", "México"],
  // mail: "ventas@cabbur.me",
  // telefono: "971 142 4420",
  // // netlifySiteId: "2c186a54-dd39-4de4-a23e-afda8447b631",
  netlifySiteId: process.env.GATSBY_NETLIFY_SITE_ID,
}

export default infoSitio
